import { useSelector } from 'react-redux';
import { UserResponse } from '@ydistri/identity-sdk';
import { ReduxState } from '../store';

export function useUser(): UserResponse | undefined {
  return useSelector((state: ReduxState) => state.userReducer.user);
}
